<div class="grid-container mat-elevation-z10">
  <div class="" style="overflow-x: auto">
    <table mat-table [dataSource]="dataSource" matSort aria-describedby="weighing tables">
        <ng-container matColumnDef="weight">
            <th mat-header-cell *matHeaderCellDef >
              {{ "weighing.grid.column.weight" | translate }}
            </th>
            <td mat-cell *matCellDef="let row">{{ row.weight }} KG</td>
        </ng-container>  
      <ng-container matColumnDef="alibi">
        <th mat-header-cell *matHeaderCellDef >
          {{ "weighing.grid.column.alibi" | translate }}
        </th>
        <td mat-cell *matCellDef="let row">{{ row.alibi }}</td>
      </ng-container>
      <ng-container matColumnDef="serial"><!--create dialog for this data-->
        <th mat-header-cell *matHeaderCellDef >
          {{ "weighing.grid.column.serial" | translate }}
        </th>
        <td mat-cell *matCellDef="let row">{{ row.serial }}</td>
      </ng-container>
      <ng-container matColumnDef="progressive_general">
        <th mat-header-cell *matHeaderCellDef >
          {{ "weighing.grid.column.progressive_general" | translate }}
        </th>
        <td mat-cell *matCellDef="let row">{{ row.progressive_general }}</td>
      </ng-container>
      <ng-container matColumnDef="partial_general">
        <th mat-header-cell *matHeaderCellDef>
          {{ "weighing.grid.column.partial_general" | translate }}
        </th>
        <td mat-cell *matCellDef="let row">{{ row.partial_general }}</td>
      </ng-container>
      <ng-container matColumnDef="device_timestamp">
        <th mat-header-cell *matHeaderCellDef>
          {{ "weighing.grid.column.device_timestamp" | translate }}
        </th>
        <td mat-cell *matCellDef="let row">{{ row.device_timestamp ?  row.device_timestamp : row.updated_at | date:'dd/MM/yyyy, HH:mm' }}</td>
      </ng-container>
      <ng-container matColumnDef="weighing_counter">
        <th mat-header-cell *matHeaderCellDef>
          {{ "weighing.grid.column.weighing_counter" | translate }}
        </th>
        <td mat-cell *matCellDef="let row">{{ row.weighing_counter }}</td>
      </ng-container>
     

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</div>